var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3536 1.35348C12.1583 1.15822 11.8417 1.15822 11.6464 1.35348L10.3429 2.65698C9.59986 2.35668 8.81369 2.17424 8.00023 2.17424C4.51977 2.17424 1.53866 5.51405 0.296117 7.1361C0.104187 7.38317 0 7.68712 0 7.99998C0 8.31283 0.104187 8.61678 0.296117 8.86385C0.715526 9.41136 1.33301 10.1546 2.10093 10.899L1.03985 11.9601C0.844583 12.1553 0.844583 12.4719 1.03985 12.6672L1.74695 13.3743C1.94221 13.5696 2.2588 13.5696 2.45406 13.3743L13.0607 2.76769C13.2559 2.57243 13.2559 2.25585 13.0607 2.06058L12.3536 1.35348ZM4.95298 8.04694L8.04707 4.95285C8.03149 4.95262 8.01587 4.9525 8.00023 4.9525C6.31709 4.9525 4.95263 6.31696 4.95263 8.0001C4.95263 8.01574 4.95275 8.03136 4.95298 8.04694ZM10.9783 7.35001L13.5533 4.77504C14.4827 5.62392 15.2236 6.50857 15.7044 7.1361C16.0988 7.6521 16.0988 8.34869 15.7044 8.86385C14.4618 10.4859 11.4807 13.8257 8.00023 13.8257C7.01452 13.8257 6.06886 13.5578 5.19141 13.1369L7.35014 10.9782C7.55961 11.0237 7.77712 11.0477 8.00023 11.0477C9.68338 11.0477 11.0478 9.68324 11.0478 8.0001C11.0478 7.77699 11.0239 7.55948 10.9783 7.35001Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.83d7d2fcbcce2ede93143f23c49d3e84.svg";
export { ForwardRef as ReactComponent };